<script>
export default {
  name: 'ChaileaseContractPrint2',
  props: {
    item: Object,
  }
};
</script>

<template>
  <div class="wrapper" v-if="item">
    <div class="page page4">


      <div class="div1">
        <table>
          <tr>

            <td width="80">{{ item.applyDate.year }}</td>
            <td width="130">{{ item.applyDate.month }} </td>
            <td width="110">{{ item.applyDate.day }} </td>
          </tr>

        </table>
      </div><!--/.div1-->
      <div class="div2">{{ item.vendor.totalPrice }}</div><!--/.div2-->
      <div class="div3">
        <table>
          <tr>
            <td width="145">普通重型 </td>
            <td width="130">{{item.laonhfcInfo.carId}}</td>
            <td width="155">{{ item.laonhfcInfo.name }}</td>
            <td width="108">{{ item.laonhfcInfo.vendor }}</td>
            <td width="115">{{ item.laonhfcInfo.manufactureDate }}</td>
            <td width="200">{{ item.laonhfcInfo.name }}</td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td> </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>

        </table>
      </div><!--/.div3-->
      <div class="div4">
      </div><!--/.div4-->
      <div class="div5">
        <table>
          <tr>
            <td>{{ item.customer.memberId }}</td>

          </tr>
          <tr>
            <td>{{ item.customer.home.residencePost }}{{ item.customer.home.residenceCity }}{{ item.customer.home.residenceArea }}{{ item.customer.home.residenceAddress }}</td>
          </tr>

        </table>
      </div><!--/.div5-->
      <div class="div6">
        <table>
          <tr>
            <td width="30"></td>
            <td>{{ item.customer.memberId }}</td>

          </tr>
          <tr>
            <td colspan="2">{{ item.customer.home.residencePost }}{{ item.customer.home.residenceCity }}{{ item.customer.home.residenceArea }}{{ item.customer.home.residenceAddress }}</td>
          </tr>

        </table>
      </div><!--/.div6-->
      <div class="div7">
        <table>
          <tr>
            <td width="180">{{ item.applyDate.year }} </td>
            <td width="230">{{ item.applyDate.month }} </td>
            <td width="230">{{ item.applyDate.day }} </td>

          </tr>


        </table>
      </div><!--/.div7-->
    </div><!--/.page-->
  </div><!--/.wrapper-->
</template>

<style scoped>
html,
body {
  height: 100%;
}

body {

}

* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.page {
  position: relative;
  width: 297mm;
  height: 420mm;
  margin: 0mm auto;
  border: 1px #D3D3D3 solid;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  font-family: Arial, "黑體-繁", "微軟正黑體", "Microsoft JhengHei", "新細明體", Helvetica, sans-serif;
  color: #0505da !important;
}

/* .page4 {
    background-image: url(images/中租掃描文件-動產抵押契約書.jpg);
    background-size: cover;
} */

@media print {
  .page {
    margin: 0;
    border: initial;
    border-radius: initial;
    box-shadow: initial;
    page-break-after: always;
  }

  .page4 {
    background-image: none;
    background-size: none;
  }
}

.wrapper {
  position: relative;
  margin: 0 auto;
  width: 100%;
  background: #fff;
  font-family: Arial, "黑體-繁", "微軟正黑體", "Microsoft JhengHei", "新細明體", Helvetica, sans-serif;
  font-size: 12px;
  padding: 0;
  margin: 0;
  font-size: 14px;
  color: #0505da !important;
  font-weight: bold;

}

table {
  width: 100%;
  margin: 0;
}

table td {
  padding: 0;

}

/*區塊*/
.div1 {
  position: absolute;
  top: 42mm;
  left: 110mm;
  text-align: center;
}

.div2 {
  position: absolute;
  top: 49mm;
  left: 130mm;
  padding: 0;
  text-align: center;
}

.div3 {
  position: absolute;
  top: 70mm;
  left: 21mm;
  padding: 0;
  text-align: center;
}

.div3 table td {
  height: 16.3mm;
}

.div4 {
  position: absolute;
  top: 198mm;
  right: 24mm;
  padding: 0;
  text-align: center;
  font-size: 16px;
}

.div5 {
  position: absolute;
  bottom: 112mm;
  left: 62mm;
}

.div5 table td {
  height: 6mm;
}

.div6 {
  position: absolute;
  bottom: 53mm;
  left: 40mm;
}

.div6 table td {
  height: 6mm;
}

.div7 {
  position: absolute;
  bottom: 39mm;
  left: 100mm;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/ChaileaseContractPrint2.vue